function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-time-menu': true
        },
      }, (function() {
        var __jade_nodes = []; /* creating/destroying picker is a simple way to reset it when menu is open */ ;
        __jade_nodes = __jade_nodes.concat(($attr(`open`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-date-range-picker-new", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'display-context': $attr(`display-context`),
              'date-range': JSON.stringify($helpers.getDateRangeAttributes()),
              'project-as-of-date': $attr(`project-as-of-date`),
              'max-history-days': $attr(`max-data-history-days`),
              'tracked-use-case': `query-builder`,
              elref: `dateRangePicker`,
            }),
            "on": {
              apply: $helpers.onDateApply,
              cancel: $helpers.onDateCancel,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;